import axios from "axios";
import { useEffect, useState } from "react";

export default function AddProductForm() {

    const [formData, setFormData] = useState({
        name: "",
        price: "",
        category: "",
        brand: "",
        description: "",
        qr_id: window.localStorage.getItem("qr_id") || ""
    });
    const [category, setCategory] = useState([]);
    const [brand, setBrand] = useState([]);

    useEffect(GetCategoriesandBrands, []);

    function GetCategoriesandBrands() {
        axios.get(`${process.env.REACT_APP_API_URL}/cat_and_brand`, {
            headers: {
                Authorization: `Bearer ${window.localStorage.getItem("token")}`
            }
        })
            .then(response => {
                setBrand(response.data.brands);
                setCategory(response.data.categories);
            })
            .catch(error => {
                console.error(error);
            });

    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log(formData);

        formData.qr_id = window.localStorage.getItem("qr_id") || "";
        if (!formData.qr_id) {
            alert("QR ID not found. Please scan the QR code again.");
            return;
        }
        e.target.innerText = "Submitting...";
        e.target.disabled = true;
        await axios.post(`${process.env.REACT_APP_API_URL}/item`, formData, {
            headers: {
                Authorization: `Bearer ${window.localStorage.getItem("token")}`

            }
        })
            .then(response => {
                console.log(response.data);
                alert("Product added successfully!");
                window.localStorage.removeItem("qr_id");
                window.location.href = `/scan/${formData.qr_id}`;
                document.getElementById("add-product-form").reset();
                // Handle successful submission
            })
            .catch(error => {
                console.error(error);
                alert("Error adding product. Please try again.");
                // Handle error
            });

    };

    return (<>
        <div className="App">
            <header className="App-header">
                <section className="top-left-corner">
                    <img src="https://pub-a3772f2b02704b91829728f4cc7bbe15.r2.dev/logo(new).svg" className="logo" alt="logo" />

                    <p>
                        Add Product
                    </p>
                </section>
            </header>
            <main>
                <form id="add-product-form">
                    <div>
                        <label>Product Name</label>
                        <input onChange={handleChange} type="text" name="name" />
                    </div>
                    <div>
                        <label>Brand</label>
                        <select onChange={handleChange} name="brand">
                            <option value="">Select Brand</option>
                            {brand.map((b, index) => (
                                <option key={index} value={b}>{b}</option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label>Model</label>
                        <input onChange={handleChange} type="text" name="model" />
                    </div>
                    <div>
                        <label>Category</label>
                        <select onChange={handleChange} name="category">
                            <option value="">Select Category</option>
                            {category.map((cat, index) => (
                                <option key={index} value={cat}>{cat}</option>
                            ))}
                        </select>
                    </div>




                    <div>
                        <label>Price</label>
                        <input onChange={handleChange} type="number" name="price" placeholder="0.00 ETB" />
                    </div>



                    <div>
                        <label>Description</label>
                        <textarea onChange={handleChange} name="description"></textarea>
                    </div>
                    <button type="submit" onClick={handleSubmit}>Add Product</button>
                </form>
            </main>
        </div>

    </>
    )
}